import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from '@hooks/auth'
import { useMsal } from '@azure/msal-react'

const AuthRoute = () => {
    const { isAuthenticated } = useAuth()
    // eslint-disable-next-line prefer-const
    let location = useLocation()

    const { inProgress } = useMsal()

    // If the user is still logging in, don't show anything
    if (inProgress === 'startup') return null

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />
    }

    return <Outlet />
}

export default AuthRoute
